import { render, staticRenderFns } from "./workGroup.vue?vue&type=template&id=f7285842&"
import script from "./workGroup.vue?vue&type=script&lang=js&"
export * from "./workGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports